<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :class="customStyle"
    viewBox="0 0 320 512"
  >
    <path
      d="M224 24.19a23.89 23.89 0 0 1-.79 6L180.61 160l-37.9 128H24a24 24 0 0 1-24-24 24.45 24.45 0 0 1 .21-3.2l32-240A24 24 0 0 1 56 0h144a24.09 24.09 0 0 1 24 24.19z"
      class="opacity-40"
    />
    <path
      d="M319.93 184.07a23.93 23.93 0 0 1-3.22 11.93l-176 304a24 24 0 0 1-44.1-17.5l46.1-194.5 37.9-128H296a24 24 0 0 1 23.93 24.07z"
      class="fa-primary"
    />
  </svg>
</template>

<script>
export default {
  name: 'BoltDuotone',
  props: {
    customStyle: {
      type: String,
      default: 'h-5 w-5',
    },
  },
}
</script>
